/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  MainSectionService,
  IMainSectionMethods,
  FooterService,
  IFooterMethods,
} from "./components";

export type TermsPageAgent = IHeaderMethods &
  IMainSectionMethods &
  IFooterMethods;

const getPlugins = () => {
  return [new HeaderService(), new MainSectionService(), new FooterService()];
};

export const getAgent = () => {
  return createAgent<TermsPageAgent>({
    plugins: getPlugins(),
  });
};
